


import { useEmpresaContext } from '../../../contexts/EmpresaContext';
import { X, CheckCircle2, Clock, AlertCircle } from 'lucide-react';

const COLUMNAS = ['Código', 'Descripción', 'Cant.', 'Precio', 'Estado'];

export default function DetalleRemito({ detalleMovStock, onClose, remito }) {
    const { getEmpresa } = useEmpresaContext();
    const empresa = getEmpresa();

    const estadoRemito = (detalle) => {
        if (detalle?.Gfaidfactura == '0' && remito?.Genfactura != '0') {
            return (
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-blue-500/10 text-blue-400 text-[9px] font-black uppercase tracking-wider">
                    <Clock size={10} /> Pendiente
                </span>
            );
        } else if (detalle?.Talonario && detalle?.Nrocomprobante) {
            return (
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-green-500/10 text-green-400 text-[9px] font-black uppercase tracking-wider">
                    <CheckCircle2 size={10} /> FAC {detalle?.Talonario}-{detalle?.Nrocomprobante}
                </span>
            );
        } else if (remito?.Genfactura == '0') {
            return (
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-white/5 text-white/30 text-[9px] font-black uppercase tracking-wider">
                    <AlertCircle size={10} /> No genera
                </span>
            );
        }
        return <span className="text-red-400 text-[9px] font-black uppercase">Falta dato</span>;
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50 p-4" onClick={onClose}>
            <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" />

            <div className="relative z-10 w-full max-w-4xl bg-gray-900 border border-white/8 rounded-2xl overflow-hidden shadow-2xl"
                onClick={e => e.stopPropagation()}>

                {/* HEADER */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-white/5">
                    <div>
                        <div className="text-[#c9a84c] text-[9px] font-black uppercase tracking-[0.6em] mb-1">
                            Detalle remito
                        </div>
                        <p className="text-white font-black text-sm tracking-wide">
                            {remito?.Talonario} - {remito?.Nrocomprobante}
                            <span className="text-white/40 font-normal ml-2 text-xs">{remito?.Fecha}</span>
                        </p>
                    </div>
                    <button onClick={onClose}
                        className="w-8 h-8 rounded-full border border-white/10 flex items-center justify-center text-white/30 hover:text-white hover:border-white/30 transition-all">
                        <X size={14} />
                    </button>
                </div>

                {/* TABLA */}
                <div className="overflow-auto max-h-80">
                    <table className="w-full border-collapse text-xs">
                        <thead>
                            <tr className="bg-gray-800 sticky top-0 z-10">
                                {COLUMNAS.map((col, i) => (
                                    <th key={i}
                                        className="px-3 py-2 border-r border-gray-700 text-white/70 font-bold uppercase tracking-wider whitespace-nowrap text-center last:border-r-0">
                                        {col}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {detalleMovStock?.length > 0 ? (
                                detalleMovStock.map((detalle, index) => (
                                    <tr key={index} className="bg-white/[0.02] hover:bg-white/[0.05] border-b border-white/5 transition-colors">
                                        <td className="px-3 py-1.5 border-r border-white/5 text-gray-400 text-center font-mono">{detalle?.Codarticulo}</td>
                                        <td className="px-3 py-1.5 border-r border-white/5 text-white/80 text-left">{detalle?.Descarticulo}</td>
                                        <td className="px-3 py-1.5 border-r border-white/5 text-gray-300 text-right font-mono">{detalle?.Cantidad}</td>
                                        <td className="px-3 py-1.5 border-r border-white/5 text-white font-black text-right font-mono">
                                            {empresa?.mostrar_precio === 'SI'
                                                ? remito?.Dolar == '1'
                                                    ? `USD ${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(detalle?.Precioarticulo)}`
                                                    : detalle?.Precioarticulo?.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })
                                                : '0'}
                                        </td>
                                        <td className="px-3 py-1.5 text-center">
                                            {estadoRemito(detalle)}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className="text-white/20 font-bold text-xs text-center py-8 uppercase tracking-widest">
                                        Sin registros
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* FOOTER */}
                <div className="px-6 py-4 border-t border-white/5 flex justify-center">
                    <button onClick={onClose}
                        className="flex items-center gap-2 px-8 py-2.5 border border-white/10 hover:border-red-500/30 hover:bg-red-500/5 text-white/30 hover:text-red-400 text-[10px] font-black uppercase tracking-widest rounded-xl transition-all duration-300">
                        <X size={12} />
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    );
}